const ZoomRedirect = () => {
    window.location.href = "https://us02web.zoom.us/j/3614385549?pwd=M29XT1pKL0JWU21DZW1NalV3L0syUT09#success"
}

export default ZoomRedirect